import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../common/Navbar";
import ContactUs from "../common/ContactUs";
import Footer from "../common/Footer";

const LandingPage = () => {
  const [token, setToken] = useState(null);
  useEffect(() => {
    document.title = "Home";
    setToken(localStorage.getItem("accessToken"))
  }, []);

  return (
    <div className="bg-white text-dark" style={{ fontFamily: 'Arial, sans-serif' }}>
      <Navbar />

      {/* Hero Section */}
      <section className="text-center bg-light" style={{ padding: '150px 0px' }}>
        <div className="container">
          <h1 className="display-2 fw-bold" id="main-font">Justice For All,</h1>
          <h2 className="display-5 fw-bold" id="main-font">Not Just the Rich</h2>
          <p className="lead mt-4" id="main-font">
            The world's first AI legal engine built for pro se litigants.
          </p>
          <p className="lead">
            We help everyday people win in court – faster, cheaper, and without a lawyer.
          </p>
          {!token && <Link className="btn btn-outline-dark mt-4 px-3 py-2" to="/register" id="main-font">
            Register
          </Link>}
        </div>
      </section>

      {/* Problem & Solution Section */}
      <section className="py-5 bg-white">
        <div className="container row mx-auto align-items-start">
          <div className="col-md-1 mb-5"></div>
          <div className="col-md-4 mb-5 col-sm-12">
            <h3 className="fw-bold mb-3 display-4" id="main-font">Money Back Guarantee<sup>*</sup></h3>
            <p className="lead mb-2">
              Hiring a lawyer costs thousands. Fighting without one? <strong>Near impossible.</strong>
            </p>
            <p>
              Millions lose in court each year not because they're wrong — but because they couldn’t afford counsel.
              This isn’t justice. It’s a price tag on people’s lives.
            </p>
            <p id="main-font" className="display-6">
              We are not lawyers. We’re justice advocates offering AI-powered motion drafting tools to help you represent yourself—clearly, confidently, and powerfully.
            </p>
          </div>
          <div className="col-md-1 mb-5"></div>
          <div className="col-md-6 mb-5 col-sm-12">
            <h3 className="fw-bold mb-3 display-4" id="main-font">Our Solution</h3>
            <p className="lead mb-2">
              Every ProSlay subscription includes full AI and human-assisted support. Here's what you get — unlimited, automated, and powerful:
            </p>
            <div className="row">
              <div className="col-12 col-md-6">
                <ul className="ps-3">
                  <li>Unlimited iMessage/WhatsApp to PDF conversions</li>
                  <li>Automated Affidavit and Certification Builder</li>
                  <li>Auto-subpoena Generator</li>
                  <li>Discovery Automation Suite</li>
                  <li>Filing Calendar & Deadline Tracker</li>
                  <li>Real-Time Motion Drafting Support</li>
                  <li>Live AI-Powered Pleading Review</li>
                  <li>Pro Se Coaching</li>
                  <li>Exhibit Compilation & Numbering Tool</li>
                  <li>Judicial Behavior Tracking</li>
                </ul>
              </div>
              <div className="col-12 col-md-6">
                <ul className="ps-3">
                  <li>Emergency Motion Templates</li>
                  <li>Weekly AI Case Progress Summaries</li>
                  <li>Document Archiving and Timestamping</li>
                  <li>Pleading Redline & Strategy Suggestions</li>
                  <li>PACER Summary Compression</li>
                  <li>Ethical Complaint Draft Assistance</li>
                  <li>No-cost updates to filings (within 7 days)</li>
                  <li>Customized Case Strategy Map</li>
                  <li>Access to ProSlay Client Success Portal</li>
                  <li>Eligibility for Refund Guarantee after 6-month subscription minimum</li>
                  <li>And more...</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Story Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h3 className="fw-bold display-4" id="main-font">See How It Works</h3>
          </div>
          <div className="row align-items-center">
            <div className="col-md-2"></div>

            {/* <div className="col-md-4">
              <div className="bg-secondary" style={{ height: '260px', borderRadius: '8px' }}></div>
            </div> */}

            <div className="col-md-8 ps-md-4">
              <blockquote className="lead fw-bold fst-italic mb-3" style={{ fontFamily: 'Playfair Display' }}>
                "I couldn't find a lawyer to fight back, so I built an AI that could."
              </blockquote>
              <div className="d-flex align-items-start">
                <img src="assets/img/Profile.jpg" alt="Profile" className="rounded-circle me-3" style={{ width: '140px', height: '140px' }} />
                <p className="mb-0">
                  Betrayed by the very system that was meant to protect him, Daniel M. Risis turned devastation into innovation. In response to fraudulent legal attacks that dismantled his life’s work, he built a new kind of weapon—AI-powered tools designed to expose corruption, restore truth, and democratize access to justice. What began as survival has become a mission to revolutionize the legal system itself.
                </p>
              </div>
            </div>

            <div className="col-md-2"></div>
          </div>
        </div>
      </section>

      {/* Join the Movement */}
      <section className="py-5 text-center bg-white">
        <div className="container">
          <h3 className="fw-bold  display-4" id="main-font">Join the Movement</h3>
          <p className="lead mt-4 mb-3">We're giving the courts back to the people — with the power of Kasper.</p>
          {!token && <Link className="btn btn-outline-dark px-4 py-2" to="/register" id="main-font">
            Register
          </Link>}
        </div>
      </section>

      {/* Contact Section */}
      <ContactUs />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
